<template>
  <div
    id="sidebar-wrapper"
    class="bg-dark border-right fixed"
    :class="{'expanded': !isSidebarCollapsed, 'collapsed': isSidebarCollapsed}"
  >
    <a
      v-if="!isSmallScreen"
      class="back-home-link"
      @click="backHome"
    >
      <img
        id="djuliLogo"
        alt="djuliLogo"
        src="../../assets/MainMenu/djuliImage.png"
        class="img-fluid w-75 mx-auto d-block"
      >
    </a>
    <b-button
      v-if="isSmallScreen"
      class="navbar-collapse-button"
      @click="toggleSidebar"
    >
      <b-icon
        :icon="isSidebarCollapsed ? 'list' : 'x'"
      />
    </b-button>
    <b-collapse
      id="sidebarNavCollapse"
      :visible="!isSidebarCollapsed || !isSmallScreen"
    >
      <div
        class="list-group list-group-flush vertical-center"
        role="tablist"
      >
        <router-link
          v-b-hover="handleNavigationHover"
          :class="{ active: isSelected(0) }"
          class="list-group-item list-group-item-action bg-dark text-center sectionSelection"
          :to="
            getCurrentClusterNavigation !== '' &&
              getCurrentProjectNavigation !== '' &&
              getCurrentIdReportViewer !== ''
              ? `/navigation/${getCurrentClusterNavigation}/${getCurrentProjectNavigation}`
              : '/navigation'
          "
          @click="setSelected(0)"
        >
          <b-icon
            v-if="hoverNavigation"
            aria-label="Navigation"
            icon="inboxes-fill"
            font-scale="3"
          />

          <b-icon
            v-else
            aria-label="Navigation"
            icon="inboxes"
            font-scale="3"
          />

          <p class="title-tab">
            Navigation
          </p>
        </router-link>
        <!-- This is needs correction -->
        <router-link
          v-b-hover="handleReportViewerHover"
          :class="{ active: isSelected(1) }"
          class="list-group-item list-group-item-action bg-dark text-center sectionSelection"
          :to="
            getCurrentClusterNavigation !== '' &&
              getCurrentProjectNavigation !== '' &&
              getCurrentIdReportViewer !== ''
              ? `/reportViewer/${getCurrentClusterNavigation}/${getCurrentProjectNavigation}/report/${getCurrentIdReportViewer}`
              : '/reportViewer/'
          "
          @click="setSelected(1)"
        >
          <b-icon
            v-if="hoverReportViewer"
            aria-label="Report Viewer"
            icon="file-earmark-spreadsheet"
            font-scale="3"
          />

          <b-icon
            v-else
            aria-label="Report Viewer"
            icon="file-earmark"
            font-scale="3"
          />

          <p class="title-tab">
            Report
          </p>
        </router-link>

        <router-link
          v-b-hover="handleTerminalHover"
          :class="{ active: isSelected(2) }"
          class="list-group-item list-group-item-action bg-dark text-center sectionSelection"
          :to="`/terminal`"
          @click="setSelected(2)"
        >
          <b-icon
            v-if="hoverTerminal"
            aria-label="Report Viewer"
            icon="terminal-fill"
            font-scale="3"
          />

          <b-icon
            v-else
            aria-label="Report Viewer"
            icon="terminal"
            font-scale="3"
          />

          <p class="title-tab">
            Terminal
          </p>
        </router-link>

        <router-link
          v-b-hover="handleAddonsHover"
          :class="{ active: isSelected(3) }"
          class="list-group-item list-group-item-action bg-dark text-center sectionSelection"
          :to="`/add-ons`"
          @click="setSelected(3)"
        >
          <b-icon
            v-if="hoverAddons"
            aria-label="MicroService"
            icon="bag-fill"
            font-scale="3"
          />

          <b-icon
            v-else
            aria-label="MicroService"
            icon="bag-dash"
            font-scale="3"
          />

          <p class="title-tab mt-1">
            Add-ons
          </p>
        </router-link>
      </div>


      <p
        class="version-text"
        @click="$router.push('/release-notes')"
      >
        djuli
        <br>
        {{ version }}
      </p>

      <a
        href="https://www.zimmerpeacock.com/"
        target="_blank"
        class="logo-zp"
      >
        <img
          id="zpLogo"
          alt="ZPLogo"
          src="../../assets/MainMenu/LogoZP.png"
          class="img-fluid w-25 mx-auto d-block"
        >
      </a>
    </b-collapse>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { BIcon } from 'bootstrap-vue';
import packageJson from './../../../package.json';
const version = packageJson.version || 0;

const RouteSelection = {
	Navigation: 0,
	ReportViewer: 1,
	Terminal: 2,
};

export default {
	name: 'Sidebar',
	components: {
		BIcon,
	},
	data() {
		return {
			selected: 0,
			hoverNavigation: false,
			hoverReportViewer: false,
			hoverTerminal: false,
			hoverAddons: false,
			version,
			isSidebarCollapsed: false,
			isSmallScreen: false,
		};
	},
	computed: mapGetters([
		'getCurrentIdReportViewer',
		'getCurrentClusterNavigation',
		'getCurrentProjectNavigation',
	]),
	watch: {
		$route(to) {
			this.highlightElement(to.name);
			this.isSidebarCollapsed = true;
		},
	},
	mounted() {
		this.updateWindowSize();
    window.addEventListener('resize', this.updateWindowSize);
		this.highlightElement(this.$route.name);
	},
	unmounted(){
		window.removeEventListener('resize', this.updateWindowSize);
	},
	updated() {
		this.highlightElement(this.$route.name);
	},
	methods: {
		...mapActions(['setCurrentProjectNavigation']),
		isSelected(i) {
			return i === this.selected;
		},
		setSelected(i) {
			this.selected = i;
		},
		highlightElement(newRoute) {
			if (newRoute in RouteSelection) {
				this.selected = RouteSelection[newRoute];
			}
		},
		handleNavigationHover(hovered) {
			//Handle the hover on the button
			this.hoverNavigation = hovered;
		},
		handleReportViewerHover(hovered) {
			//Handle the hover on the button
			this.hoverReportViewer = hovered;
		},
		handleTerminalHover(hovered) {
			//Handle the hover on the button
			this.hoverTerminal = hovered;
		},
		handleAddonsHover(hovered) {
			//Handle the hover on the button
			this.hoverAddons = hovered;
		},
		backHome() {
			this.setCurrentProjectNavigation(''); //Reset the navigation
			if (this.$route.name !== 'Navigation') {
				this.$router.push({ name: 'Navigation' });
			}
		},
		toggleSidebar() {
			this.isSidebarCollapsed = !this.isSidebarCollapsed;
    },
		updateWindowSize() {
      this.isSmallScreen = window.innerWidth < 1160;
			if(this.isSmallScreen){
				this.isSidebarCollapsed = true;
			}
    },
	},
};
</script>

<style scoped>
div#sidebar-wrapper {
	height: 100vh;
	width: 6vw;
	z-index:100;
}

.vertical-center {
	margin: 0;
	position: absolute;
	top: 50%;
	-ms-transform: translateY(-50%);
	transform: translateY(-50%);
	width: 5.5vw;
}

a.sectionSelection {
	font-size: 0.9rem;
	text-align: center;
	color: #a1aaa2;
	padding-left: 0px !important;
	padding-right: 0px !important;
}

a.sectionSelection.active {
	color: #fff;
}

.title-tab {
	margin: 0;
}

.logo-zp {
	bottom: 2rem;
	position: absolute;
	width: 6vw;
}

.version-text {
	position: absolute;
	bottom: 4rem;
	width: 6vw;
	text-align: center;
	color: #aaa;
	font-size: 0.75rem;
	font-weight: bold;
	cursor: pointer;
}

.back-home-link {
	cursor: pointer;
}

/* Media query for screen sizes less than px */
@media (max-width: 1160px) {
  div#sidebar-wrapper.collapsed {
    height: 4vh; /* Collapsed height */
		width: 8vw;
		background-color: white;
    transition: height 0.3s ease; /* Smooth transition animation */
  }
	div#sidebar-wrapper.expanded  {
    height: 100vh; /* Expanded height */
		width: 30vw;
  }
	div.vertical-center {
		width: 10vw;
	}
	a.sectionSelection {
		margin: 2px !important;
	}
	.logo-zp {
	width: 10vw;
	}
	.version-text {
		width: 10vw;
	}
}
.navbar-collapse-button{
	left: 0rem;
	position: absolute;
	z-index:101;
	background-color: #4DBF45;
	width: 8vw;
}
</style>
